import React, { useState,useEffect } from 'react';
import axios from 'axios';
import AttendanceCalendar from './AttendanceCalendar';
import dayjs from 'dayjs';

function StudentAttendance() {
    const [activeTab, setActiveTab] = useState('today');
    const today = new Date();
    const formattedDate = today.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    });
    
    const [attendance, setAttendance] = useState(null);
    useEffect(() => {
        const fetchToday = async () => {
        try {
            const res = await axios.get(`/api/student/get-student-todays-attendance`);
            setAttendance(res.data);
        } catch (err) {
            console.error('Error loading attendance', err);
        }
        };
        fetchToday();
    }, []);

    return (
        <div className="row gy-44">
            <div className="col-xxl-6">
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
                    <div className="card-header py-16 px-24 bg-base border border-end-0 border-start-0 border-top-0">
                    <h3 className="mb-0">Attendance</h3>
                    </div>
                    <div className="card-body p-24 pt-10">
                    <ul className="nav button-tab nav-pills mb-16" role="tablist">
                        <li className="nav-item" role="presentation">
                        <button
                            className={`border nav-link fw-semibold text-primary-light radius-4 px-16 py-10 ${activeTab === 'today' ? 'active' : ''}`}
                            type="button"
                            role="tab"
                            onClick={() => setActiveTab('today')}
                        >
                            View Today's
                        </button>
                        </li>
                        <li className="nav-item" role="presentation">
                        <button
                            className={`border nav-link fw-semibold text-primary-light radius-4 px-16 py-10 ${activeTab === 'monthly' ? 'active' : ''}`}
                            type="button"
                            role="tab"
                            onClick={() => setActiveTab('monthly')}
                        >
                            View Monthly
                        </button>
                        </li>
                    </ul>

                    <div className="tab-content">
                        {activeTab === 'today' && (
                        <div className="tab-pane fade active show" role="tabpanel">
                            <div className="d-flex align-items-center gap-3">
                                <div className="flex-grow-1">
                                    <span className='panelHeading'>{formattedDate}</span>
                                    {attendance?.in_time ? (
                                    <div>
                                        <strong>In:</strong> {dayjs(attendance.in_time, 'HH:mm:ss').format('h:mm A')} &nbsp;&nbsp;
    <strong>Out:</strong> {attendance.out_time ? dayjs(attendance.out_time, 'HH:mm:ss').format('h:mm A') : 'N/A'}
                                    </div>
                                    ) : (
                                        <span>No data</span>
                                    )}
                                </div>
                            </div>
                        </div>
                        )}

                        {activeTab === 'monthly' && (
                        <div className="tab-pane fade active show" role="tabpanel">
                            <div className="d-flex align-items-center gap-3">
                                <div className="flex-grow-1">
                                    <AttendanceCalendar />
                                </div>
                            </div>
                        </div>
                        )}
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default StudentAttendance;